import { Divider, Grid, List, ListItem, ListItemText, Switch } from "@mui/material";
import { useState } from "react";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useUserStore } from "../../../hooks/UseUserStore";

type Values = {
    id: number,
    rut: string,
}

const documents = [
    { id: 1, name: 'Boleta', status: 1},
    { id: 2, name: 'Factura', status: 0},
    { id: 3, name: 'Vista de caja', status: 1},
    { id: 4, name: 'Nota de crédito', status: 1},
    { id: 5, name: 'Nota de débito', status: 1},
    { id: 6, name: 'Cotización', status: 0},
    { id: 7, name: 'Nota de venta', status: 1},
    { id: 8, name: 'Nota de venta', status: 0},
    { id: 9, name: 'Nota de venta', status: 0},
    { id: 10, name: 'Nota de venta', status: 1},
    { id: 11, name: 'Nota de venta', status: 0},
]

const halfLength = Math.ceil(documents.length / 2);
const firstHalf = documents.slice(0, halfLength) || [];
const secondHalf = documents.slice(halfLength) || [];

export const TabDocuments: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, userSelected, listUser, clearState } = props;

    const { editUser } = useUserStore();

    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(['wifi']);
    const [data, setData] = useState<Values>({
        id: userSelected ? userSelected.id :'',
        rut: userSelected ? userSelected.rut :'',
    });

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];
    
        if (currentIndex === -1) {
          newChecked.push(value);
        } else {
          newChecked.splice(currentIndex, 1);
        }
    
        setChecked(newChecked);
    };

    const onSubmit = async(values)  => {
        setLoading(true);

        const formdata = {
            ...values,
            type_person: '0',
            age: (values.age).toString(),
        }
        const response:any = await editUser(userSelected.id, formdata);
        if(response){
            listUser && listUser();
            closeModal && closeModal();
            clearState && clearState();
            setLoading(false);
        }else{
            setLoading(false);
            return false;
        }
    }

    return (
        <Grid >
            <Grid container>
                <Grid item container xs={12} spacing={2} display='flex' justifyContent='space-between'>
                    <Grid item xs={12} md={5}>
                    {
                        firstHalf.length > 0 && firstHalf.map((item) => (
                            <List
                                sx={{ width: '100%', bgcolor: 'background.paper' }}
                            >
                                <ListItem>
                                    <ListItemText id = "switch-list-label-wifi" primary = {item.name} />
                                    <Switch
                                        edge="end"
                                        onChange={handleToggle('wifi')}
                                        checked={item.status == 1 ? true : false}
                                        inputProps={{
                                            'aria-labelledby': 'switch-list-label-wifi',
                                        }}
                                    />
                                </ListItem>
                            </List>
                        ))
                    }
                    </Grid>
                    <Grid item xs={12} md={5}>
                    {
                        secondHalf.length > 0 && secondHalf.map((item) => (
                            <List
                                sx={{ width: '100%', bgcolor: 'background.paper' }}
                            >
                                <ListItem>
                                    <ListItemText id = "switch-list-label-wifi" primary = {item.name} />
                                    <Switch
                                        edge="end"
                                        onChange={handleToggle('wifi')}
                                        checked={item.status == 1 ? true : false}
                                        inputProps={{
                                            'aria-labelledby': 'switch-list-label-wifi',
                                        }}
                                    />
                                </ListItem>
                            </List>
                        ))
                    }
                    </Grid>
                </Grid>
            </Grid>
            <Divider />
            <ModalFooter 
                buttonType="submit"
                confirmText={'Guardar'}
                onConfirm={onSubmit}
                cancelText={"Cancelar"}
                onCancel={closeModal}
                loadingConfirmText={loading}
                clearState={clearState}
            />
        </Grid>
    )
}